import React from 'react';
import { QuickActions } from '@/components/ui';
import { Calendar as CalendarIcon, Users, FileText, DollarSign, Settings } from 'lucide-react';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function QuickActionsSection() {
  return (
    <SectionWrapper title="Quick Actions">
        <div>
          <h3 className="text-lg font-semibold mb-4">Basic Quick Actions</h3>
          <div className="space-y-6">
            {/* Standard 2-column layout */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <QuickActions
                title="Client Dashboard Actions"
                items={[
                  {
                    title: 'Events',
                    description: 'Manage events for this client',
                    icon: <CalendarIcon className="w-6 h-6" />,
                    href: '#',
                    count: 5,
                    onClick: () => {},
                  },
                  {
                    title: 'Invoices',
                    description: 'View and manage invoices',
                    icon: <FileText className="w-6 h-6" />,
                    href: '#',
                    comingSoon: true,
                  },
                  {
                    title: 'Transactions',
                    description: 'Payment history and records',
                    icon: <DollarSign className="w-6 h-6" />,
                    href: '#',
                    comingSoon: true,
                  },
                  {
                    title: 'Settings',
                    description: 'Client preferences and configuration',
                    icon: <Settings className="w-6 h-6" />,
                    href: '#',
                    comingSoon: true,
                  },
                ]}
                columns={2}
              />
            </div>

            {/* Single column layout */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <QuickActions
                title="Single Column Layout"
                items={[
                  {
                    title: 'Members',
                    description: 'Manage team members and roles',
                    icon: <Users className="w-6 h-6" />,
                    href: '#',
                    count: 42,
                    onClick: () => {},
                  },
                  {
                    title: 'Reports',
                    description: 'Analytics and performance data',
                    icon: <FileText className="w-6 h-6" />,
                    href: '#',
                    comingSoon: true,
                  },
                ]}
                columns={1}
              />
            </div>

            {/* Without title */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <h4 className="text-sm font-medium mb-3">Without Title Prop</h4>
              <QuickActions
                items={[
                  {
                    title: 'Quick Action',
                    description: 'This layout has no title prop',
                    icon: <CalendarIcon className="w-6 h-6" />,
                    href: '#',
                    onClick: () => {},
                  },
                ]}
                columns={1}
              />
            </div>
          </div>
          <CodeBlock>
{`// Standard usage with counts and coming soon badges
<QuickActions
  title="Quick Actions"
  items={[
    {
      title: 'Events',
      description: 'Manage events for this client',
      icon: <Calendar className="w-6 h-6" />,
      href: '/events',
      count: 5,
      onClick: () => navigate('/events'),
    },
    {
      title: 'Reports',
      description: 'Analytics and performance',
      icon: <FileText className="w-6 h-6" />,
      href: '#',
      comingSoon: true,
    },
  ]}
  columns={2}
/>

// Mobile-responsive features:
// - Icons vertically centered on all screen sizes
// - Count badges inline with title
// - "Coming Soon" badges below title/description on mobile
// - Actions stack on mobile, side-by-side on desktop
// - Touch-friendly spacing and tap targets`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
